// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Axios from 'axios';
import vueHeadful from 'vue-headful';
import VueToastr from 'vue-toastr';
import App from './App';
import router from './router';
import store from './store';


Vue.prototype.$http = Axios;

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = token;
}

Vue.component('vue-headful', vueHeadful);

Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
});

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App,
  },
  template: '<App/>',
  store,
  mounted() {
    this.$toastr.defaultPosition = 'toast-top-right';
    this.$toastr.type = 'error';
  },
});



// WEBPACK FOOTER //
// ./src/main.js